import { Component } from "@angular/core";
import  build  from "../../../build";
import { environment } from "../../../environments/environment";

@Component({
  selector: "version-info",
  templateUrl: "./version-info.component.html",
  styleUrls: ["./version-info.component.scss"],
})
export class VersionInfoComponent {
  public curEnv = environment.production ? "ייצור" : "פיתוח";
  public curBuild = build.version;
  public curTimestamp = build.timestamp;
  public curMessage = build.message || "אין הודעה";
  public curGitUser = build.git.user;
  public curGitBranch = build.git.branch;
  public curGitHash = build.git.fullHash;
  constructor() {}
}
